export const iosDeviceIds = {
    ipadSpain: 'bea752e4-8847-4ed9-8853-82bd27e0bc58',
    ipadItaly: '9662680a-9980-4098-a0a6-ff4b3992feee',
    iPhoneSpain: 'b88d9586-dcb7-4218-848c-94f9d518961d',
    iPhoneItaly: '6c726972-026e-420c-a743-53c8649101bf',
};